import React from 'react'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import injectSheet from 'react-jss'
import { Link } from 'react-router-dom'

const styleSheet = theme => ({
    submitButtonStyle: {
        fontSize: 26,
        fontWeight: 600,
        color: theme.palette.common.white,
        display: 'block',
        width: '30%',
        position: 'relative',
        top: ({ isSmallScreen }) => (isSmallScreen ? '60%' : '50%'),
        left: '50%',
        transform: 'translate(-50%, -50%)',
        margin: ({ vertical }) => (vertical ? '3.5% 0 0 0' : 0),
        textAlign: 'center',
        padding: '4% 20%',
        zIndex: '2',
        textTransform: 'uppercase',
        boxShadow: 'rgba(0, 0, 0, 0.35) 3px 4px 6px 0px',
        background: 'rgb(0, 181, 209)',
        borderRadius: 5,
    },
})

const style = injectSheet(styleSheet)

const SubmitButton = ({ classes, onClick, label = 'start', linkURL, replace }) => (
    <Link to={linkURL} onClick={onClick} className={classes.submitButtonStyle} replace={replace}>
        {label}
    </Link>
)

export default compose(
    style,
    pure
)(SubmitButton)
